import { Navbar } from "../shared/components/Navbar.tsx"
import { DashedLine } from "../shared/components/DashedLine.tsx"
import { useLanguage } from "../shared/context/LanguageContext.tsx";

export function TermsConditions() {
    const { translation } = useLanguage();

    const termsConditionsContent = [
        {
            title: translation.intellectualProperty,
            description: translation.intellectualPropertyDesc,
        },
        {
            title: translation.amendments,
            description: translation.amendmentsDesc,
        },
        {
            title: translation.governingLaw,
            description: translation.governingLawDesc,
        },
        {
            title: translation.consent,
            description: translation.consentDesc,
        },
    ]
    
    return (
        <main>
            <div className="sticky top-5 sm:top-0 md:relative z-50 mx-5 md:mx-7 lg:mx-10 xl:mx-[3.125rem] bg-secondary rounded-3xl">
                <Navbar />
            </div>
            <div className="flex flex-col gap-5 px-5 md:gap-9 md:py-9 md:px-9 lg:flex-row lg:gap-20 lg:py-0 lg:pt-[4.375rem] lg:px-[5.625rem]">
                <div className="min-w-[25%] text-[1.75rem] md:text-3xl lg:text-[2.5rem] font-bold px-5 pt-9 lg:px-0 lg:pt-0 text-primary !leading-[130%]">{translation.termsAndConditions}</div>
                <div className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem] px-5 lg:px-0 pb-[1.875rem] ld:pb-0 text-base md:text-lg lg:text-[1.375rem]">
                    <div className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem]">
                        <div className="flex flex-col gap-2.5">
                            <div className="font-bold text-primary whitespace-pre-line !leading-[130%] lg:leading-9">
                                {translation.introduction}
                            </div>
                            <div className="font-normal text-black whitespace-pre-line !leading-[130%] lg:leading-9">
                                {translation.introductionDesc}
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col gap-2.5">
                        <div className="text-primary !leading-[130%] lg:leading-9">
                            {translation.services}
                        </div>
                        {Array.isArray(translation.servicesDesc) && translation.servicesDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                {desc}
                            </li>
                        ))}
                    </div>
                    <div className="flex flex-col gap-2.5">
                        <div className="text-primary !leading-[130%] lg:leading-9">
                            {translation.supportInfo}
                        </div>
                        {Array.isArray(translation.supportInfoDesc) && translation.supportInfoDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                {desc}
                            </li>
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary !leading-[130%] lg:leading-9">
                            {translation.definitions}
                        </div>
                        {Array.isArray(translation.definitionsDesc) && translation.definitionsDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                <span className="font-medium">{desc.bold}</span> {desc.description}
                            </li>
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary whitespace-pre-line !leading-[130%] lg:leading-9">
                            {translation.eligibilityAndAgreement}
                        </div>
                        {Array.isArray(translation.eligibilityAndAgreementDesc) && translation.eligibilityAndAgreementDesc.map((desc, i) => (
                            i === 0 ||i === 5 ? (
                                <div className="font-normal text-black whitespace-pre-line !leading-[130%] lg:leading-9">
                                    {desc}
                                </div>
                            ) : (
                                <li key={i} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                    {desc}
                                </li>
                            )
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary whitespace-pre-line !leading-[130%] lg:leading-9">
                            {translation.accountRegistration}
                        </div>
                        {Array.isArray(translation.accountRegistrationDesc) && translation.accountRegistrationDesc.map((desc, i) => (
                            i === 0 ? (
                                <div className="font-normal text-black whitespace-pre-line !leading-[130%] lg:leading-9">
                                    {desc}
                                </div>
                            ) : (
                                <li key={i} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                    {desc}
                                </li>
                            )
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary !leading-[130%] lg:leading-9">
                            {translation.transactions}
                        </div>
                        {Array.isArray(translation.transactionsDesc) && translation.transactionsDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                {desc}
                            </li>
                        ))}
                    </div>
                    <div className="flex flex-col gap-2.5">
                        <div className="text-primary !leading-[130%] lg:leading-9">
                            {translation.support}
                        </div>
                        {Array.isArray(translation.supportInfoDesc) && translation.supportInfoDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                {desc}
                            </li>
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary whitespace-pre-line !leading-[130%] lg:leading-9">
                            {translation.dataPrivacyAndSecurity}
                        </div>
                        {Array.isArray(translation.dataPrivacyAndSecurityDesc) && translation.dataPrivacyAndSecurityDesc.map((desc, i) => (
                            i === 0 || i === 3 ? (
                                <div className="font-normal text-black whitespace-pre-line !leading-[130%] lg:leading-9">
                                    {desc}
                                </div>
                            ) : (
                                <li key={i} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                    {desc}
                                </li>
                            )
                        ))}
                    </div>
                    <DashedLine />
                    <div className="flex flex-col gap-2.5">
                        <div className="font-bold text-primary">
                            {translation.fraud}
                        </div>
                        {Array.isArray(translation.fraudDesc) && translation.fraudDesc.map((desc, index) => (
                            <li key={index} className="font-normal text-black ms-6 md:ms-7 lg:ms-8 !leading-[130%] lg:leading-9">
                                {desc}
                            </li>
                        ))}
                    </div>
                    <DashedLine />
                    {termsConditionsContent.map((item, index) => (
                        <div key={index} className="flex flex-col gap-5 md:gap-6 lg:gap-[1.875rem]">
                            <div className="flex flex-col gap-2.5">
                                <div className="font-bold text-primary whitespace-pre-line !leading-[130%] lg:leading-9">
                                    {item.title}
                                </div>
                                <div className="font-normal text-black whitespace-pre-line !leading-[130%] lg:leading-9">
                                    {item.description}
                                </div>
                            </div>
                            {index !== termsConditionsContent.length - 1 && <DashedLine key={index} />}
                        </div>
                    ))}
                </div>
            </div>
        </main>
    )
}